module.exports = __webpack_public_path__ + "assets/img/Dempsey Hill.bc0e4cb8.jpg";